import { Alert, AlertTitle } from "@mui/material";
import type { FC } from "react";

export interface AutocompleteErrorMessageProps {
  error?: Error;
  isLogin?: boolean;
}

export const AutocompleteErrorMessage: FC<AutocompleteErrorMessageProps> = ({
  // biome-ignore lint/correctness/noUnusedFunctionParameters: ToBeEvaluated with the team
  error,
  isLogin,
}) => {
  return (
    <Alert sx={{ mx: -2, my: -1.8 }} severity="error">
      {isLogin ? (
        <>
          <AlertTitle>
            An unexpected error occurred. Please try refreshing the website.
          </AlertTitle>
          {/* {error.message} */}
        </>
      ) : (
        <AlertTitle>Please login to see your filter options.</AlertTitle>
      )}
    </Alert>
  );
};
